export default {
  handleShowChatVisaFrame(state, data) {
    state.showChatVisaFrame = true;
    state.visa_country_id = data.visa_country_id || 0;
    state.sensorData = data.sensorData || {};
  },
  handleCloseChatVisaFrame(state) {
    state.showChatVisaFrame = false;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/chat-visa/chat-visa-mutations.js